import { isPlatformServer, NgIf } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { HelperFunctions, IActivityLocation, IBoondockPoint, ILatLon, IListingPoint } from '@curbnturf/entities';
import { IonicModule } from '@ionic/angular';
import { OpenStreetMapComponent } from '@curbnturf/map/src/lib/open-street-map/open-street-map.component';

@Component({
  standalone: true,
  selector: 'curbnturf-location-map',
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.scss'],
  imports: [IonicModule, NgIf, OpenStreetMapComponent],
})
export class LocationMapComponent implements OnInit, AfterViewInit {
  @ViewChild('mapContainer', { static: true }) mapContainerEl: ElementRef;

  @ViewChild('openStreetMap') public openStreetMapComponent: OpenStreetMapComponent;

  @Input() activities?: IActivityLocation[];
  @Input() boondockPoint?: IBoondockPoint;
  @Input() point?: IListingPoint;

  zoom: number = 12;

  hideMap: boolean = true;

  get coordinates(): ILatLon {
    if (this.point?.coordinates) {
      return this.point.coordinates;
    }

    if (this.activities && this.activities.length > 0 && this.activities[0].coordinates) {
      return this.activities[0].coordinates;
    }

    return HelperFunctions.getDefaultLocation();
  }

  get points(): IListingPoint[] {
    if (this.point) {
      return [this.point];
    }
    return [];
  }

  get boondockPoints(): IBoondockPoint[] {
    if (this.boondockPoint) {
      return [this.boondockPoint];
    }
    return [];
  }

  constructor(@Inject(PLATFORM_ID) private platformId: string) {}

  ngOnInit() {
    this.hideMap = isPlatformServer(this.platformId);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.openStreetMapComponent.setMapZoom(this.zoom);
    }, 500);
  }
}
